export default __webpack_public_path__ + "static/headshot-f98cb2e03a369a07774448f49a3de415.png";